module.exports = __webpack_public_path__ + "media/images/climatisation-6f054e53711d61215ad967cca8c0a0b3.svg";